import { render, staticRenderFns } from "./DataScienceFaq.vue?vue&type=template&id=41c2589a&scoped=true&"
import script from "./DataScienceFaq.vue?vue&type=script&lang=js&"
export * from "./DataScienceFaq.vue?vue&type=script&lang=js&"
import style0 from "./DataScienceFaq.vue?vue&type=style&index=0&id=41c2589a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2589a",
  null
  
)

export default component.exports